import { Injectable } from '@angular/core';
import { GenericResponse } from 'projects/Autofacets-Core/src/app/business-entities/generic-response.class';
import { DealerLunchShiftModel, DealerOpeningHoursViewModel, DealerShiftRequestModel } from './../business-entities/dealer-opening-hours-view-model';
import { DealerWorkingHoursDataService } from './../data-services/dealer-working-hours-data.service'
import { DealerCustomerWaitingHoursViewModel } from '../business-entities/dealer-customer-waiting-hours-view-model';

@Injectable({ providedIn: 'root' })
export class DealerWorkingHoursBusinessService {

    constructor(
        private dealerWorkingHoursDataService: DealerWorkingHoursDataService
    ) {}

    async getDealerWorkingHoursDetails(dealerId: string,occasionId:number): Promise<DealerOpeningHoursViewModel[]> {
        let returnValue: DealerOpeningHoursViewModel[] = [];
        await this.dealerWorkingHoursDataService.getDealerWorkingHoursDetails(dealerId,occasionId).then((result) => {
            returnValue = result.responseObject;
        });
        return returnValue;
    }

    GetDealerLunchShiftDetails(dealerId: string): Promise<GenericResponse<any>> {
      return this.dealerWorkingHoursDataService.GetDealerLunchShiftDetails(dealerId);
    }

    updateDealerWorkingHours(dealerWorkingHours: DealerShiftRequestModel): Promise<GenericResponse<any>> {
        return this.dealerWorkingHoursDataService.updateDealerWorkingHours(dealerWorkingHours);
    }
    AddEditSpecialOccasion(occasionalShiftSaveViewModel:any){
        return this.dealerWorkingHoursDataService.AddEditSpecialOccasion(occasionalShiftSaveViewModel);
    }
    GetSpecialOccasionList(dealerId:string){
        return this.dealerWorkingHoursDataService.GetSpecialOccasionList(dealerId);
    }
    DeleteSpecialOccasion(occasionalShiftDeleteViewModel:any){
        return this.dealerWorkingHoursDataService.DeleteSpecialOccasion(occasionalShiftDeleteViewModel);
    }

    //Dealer Customer Waiting Hours
    async getDealerCustomerWaitingHoursDetails(dealerId: string): Promise<GenericResponse<any>>  {
        return this.dealerWorkingHoursDataService.getDealerCustomerWaitingHoursDetails(dealerId);
    }

    async addUpdateDealerCustomerWaitingHours(dealerCustomerWaitingHours: any): Promise<GenericResponse<any>>{
        return this.dealerWorkingHoursDataService.addUpdateDealerCustomerWaitingHours(dealerCustomerWaitingHours);
    }

    async getDealerCustomerWaitingHoursDetailsById(dealerId: string, occasionId: number): Promise<GenericResponse<any>> {
        return this.dealerWorkingHoursDataService.getDealerCustomerWaitingHoursDetailsById(dealerId, occasionId);
    }

    async saveDealerCustomerWaitingHours(dealerCustomerWaitingHoursSaveModel: any): Promise<GenericResponse<any>> {
        return this.dealerWorkingHoursDataService.saveDealerCustomerWaitingHours(dealerCustomerWaitingHoursSaveModel);
    }

    async deleteDealerCustomerWaitingHours(dealerCustomerWaitingHoursDeleteModel: any): Promise<GenericResponse<any>> {
        return this.dealerWorkingHoursDataService.deleteDealerCustomerWaitingHours(dealerCustomerWaitingHoursDeleteModel);
    }

    async deleteDealerCustomerWaitingSlotHours(occasionId: any): Promise<GenericResponse<any>> {
        return this.dealerWorkingHoursDataService.deleteDealerCustomerWaitingSlotHours(occasionId);
    }
}